import { parsePhoneNumberFromString } from 'libphonenumber-js';

function preprocessPhone(value: string): string {
  const sanitized = value.replace(/\s+/g, '');

  if (sanitized.startsWith('06')) {
    return '+31' + sanitized.slice(1);
  }

  return sanitized;
}

export function validatePhonenumber(phone: string) {
  const normalized = preprocessPhone(phone);

  const validateResult = parsePhoneNumberFromString(normalized, {
    defaultCountry: 'NL',
  });

  return validateResult?.isValid() ?? false;
}
